import { render, staticRenderFns } from "./TikTokIntegrationButton.vue?vue&type=template&id=7cd908e8"
import script from "./TikTokIntegrationButton.vue?vue&type=script&lang=js"
export * from "./TikTokIntegrationButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports